import Vue from 'vue'
import merge from 'lodash.merge'
import browserLocale from 'browser-locale'

const DEFAULT_STATE = {
  interpolate: true,
  colorblind: false,
  experimental: false,
  airspace: false,
  xcplanner: false,
  altitude: 1000,
  center: {
    lat: 45,
    lon: 5,
    zoom: 7,
    defaultValues: true
  },
  layer: 'pbltop',
  splitRatio: 0.5,
  lang: undefined,
  windUnit: 'kmh',
  appOpenCount: 0,
  dissmissedNews: new Date(0),
  acceptedRules: new Date(0),
  timezone: undefined,
  timezoneOveride: false,
  iapEmail: null,
  soundingTopAltitude: 4000,
  windgramTopAltitude: 4000
}

export default {
  namespaced: true,
  state: DEFAULT_STATE,
  getters: {
    roundedAltitude(state) {
      return Math.round(state.altitude / 250) * 250
    }
  },
  mutations: {
    toggleInterpolation(state) {
      state.interpolate = !state.interpolate
    },
    toggleAirspace(state) {
      state.airspace = !state.airspace
    },
    toggleXcplanner(state) {
      state.xcplanner = !state.xcplanner
    },
    toggleColorblind(state) {
      state.colorblind = !state.colorblind
    },
    toggleExperimental(state) {
      state.experimental = !state.experimental
    },
    climbAltitude(state, height) {
      let altitude = state.altitude + height
      if (altitude < 250) {
        altitude = 250
      } else if (altitude > 5000) {
        altitude = 5000
      }
      state.altitude = altitude
    },
    setRouteParams(state, { lat, lon, zoom, layer, altitude }) {
      state.center = {
        lat,
        lon,
        zoom,
        defaultValues: false
      }
      // if (layer !== undefined) state.layer = layer
      // if (altitude !== undefined) state.altitude = altitude
    },
    setLayer(state, layer) {
      state.layer = layer
    },
    setCenter(state, { lat, lon, zoom }) {
      state.center = {
        lat,
        lon,
        zoom,
        defaultValues: false
      }
    },
    setSplitRatio(state, ratio) {
      state.splitRatio = ratio
    },
    load(state, savedState) {
      const newState = merge({}, state, savedState)
      Object.assign(state, newState)
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE)
    },
    setLang(state, lang) {
      state.lang = lang
    },
    setWindUnit(state, unit) {
      state.windUnit = unit
    },
    incrementAppOpenCount(state) {
      state.appOpenCount++
    },
    dissmissNews(state, timestamp) {
      state.dissmissedNews = timestamp
    },
    acceptRules(state, timestamp) {
      state.acceptedRules = timestamp
    },
    syncConfig(state) {
      const setLang = function (lang) {
        const systemLanguage = lang.split('-')[0]
        if (systemLanguage in Vue.$translations) {
          state.lang = systemLanguage
        } else {
          state.lang = 'en'
        }
        Vue.config.language = state.lang
      }

      Vue.config.windUnit = state.windUnit
      Vue.config.timezone = state.timezone

      if (state.lang === undefined) {
        if ('cordova' in window) {
          navigator.globalization.getPreferredLanguage(
            language => {
              setLang(language.value)
            },
            () => {
              setLang('en')
            }
          )
        } else {
          setLang(browserLocale())
        }
      } else {
        Vue.config.language = state.lang
      }
    },
    setTimezone(state, timezone) {
      state.timezone = timezone
      Vue.config.timezone = state.timezone
    },
    setTimezoneOveride(state, overide) {
      state.timezoneOveride = overide
    },
    setIapEmail(state, email) {
      state.iapEmail = email
    },
    setSoundingTopAltitude(state, altitude) {
      state.soundingTopAltitude = altitude
    },
    setWindgramTopAltitude(state, altitude) {
      state.windgramTopAltitude = altitude
    }
  },
  actions: {
    toggleInterpolation(context) {
      context.commit('toggleInterpolation')
    },
    toggleAirspace(context) {
      context.commit('toggleAirspace')
    },
    toggleXcplanner(context) {
      context.commit('toggleXcplanner')
    },
    toggleExperimental(context) {
      context.commit('toggleExperimental')
    },
    toggleColorblind(context) {
      context.commit('toggleColorblind')
    },
    climbAltitude(context, height) {
      context.commit('climbAltitude', height)
    },
    setRouteParams(context, params) {
      context.commit('setRouteParams', params)
    },
    setLayer(context, layer) {
      context.commit('setLayer', layer)
    },
    setSplitRatio(context, ratio) {
      context.commit('setSplitRatio', ratio)
    },
    incrementAppOpenCount(context) {
      context.commit('incrementAppOpenCount')
    },
    setUserLocation(context) {
      /* if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(location => {
          context.commit('setCenter', {
            lat: location.coords.latitude,
            lon: location.coords.longitude,
            zoom: 7
          })
        },
        () => {
          context.dispatch('setIpLocation')
        })
      } else {
        context.dispatch('setIpLocation')
      } */
      context.dispatch('setIpLocation')
    },
    setIpLocation(context) {
      /* Vue.http.get('https://freegeoip.net/json/')
      .then(({ body: response }) => {
        context.commit('setCenter', {
          lat: response.latitude,
          lon: response.longitude
        })
      }) */
    },
    load(context, savedState) {
      context.commit('load', savedState)
    },
    resetStore(context) {
      context.commit('resetStore')
      context.commit('syncConfig')
    },
    setLang(context, lang) {
      context.commit('setLang', lang)
      context.commit('syncConfig')
    },
    setWindUnit(context, unit) {
      context.commit('setWindUnit', unit)
      context.commit('syncConfig')
    },
    syncConfig(context) {
      context.commit('syncConfig')
    },
    dissmissNews(context, timestamp) {
      context.commit('dissmissNews', timestamp)
    },
    acceptRules(context, timestamp) {
      context.commit('acceptRules', timestamp)
    },
    setTimezone(context, timezone) {
      context.commit('setTimezone', timezone)
    },
    setTimezoneOveride(context, overide) {
      context.commit('setTimezoneOveride', overide)
    },
    setIapEmail(context, email) {
      context.commit('setIapEmail', email)
    },
    setSoundingTopAltitude(context, altitude) {
      context.commit('setSoundingTopAltitude', altitude)
    },
    setWindgramTopAltitude(context, altitude) {
      context.commit('setWindgramTopAltitude', altitude)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/persistent.js